module.exports = __webpack_public_path__ + "wxMicroService/img/unlicensed.fc8a01aa.png";